import axios from 'axios'
import Service, { prepareURL } from '@/api/service'
import getFormDataFromJSON from '@/common/js/formdata'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

/*
    using '...Service('/url/:id/')' in object provides methods:
        fetch
        get
        delete
        put
        save
 */

export const SiteSettings = {
  update: payload => {
    return axios.put('/admin/core/settings/', payload)
  },
  get: payload => {
    return axios.get('/admin/core/settings/', payload)
  }
}

export const Attachment = {
  ...Service('/admin/attachments/:id/'),
  upload: payload => {
    return axios.post('/admin/attachments/', payload, {
      headers: { 'content-type': 'multipart/form-data' }
    })
  }
}

export const Page = {
  ...Service('/admin/pages/:id/'),
  revision(params, payload) {
    const url = prepareURL(`/admin/pages/:id/revision/`, params)
    return axios.post(url, payload)
  }
}

export const Revision = Service('/admin/revisions/:id/')

export const Article = {
  ...Service('/admin/articles/:id/'),
  preview(urlParams, payload) {
    const url = '/admin/articles/:id/preview/'
    return axios.post(prepareURL(url, urlParams), payload)
  },
  revision(params, payload) {
    const url = prepareURL(`/admin/articles/:id/revision/`, params)
    return axios.post(url, payload)
  },
  usedTags(params) {
    return axios.get('/admin/articles/used-tags/', { params })
  }
}

export const ArticleTag = {
  ...Service('/admin/articles/tags/:id/')
}

export const CompetitionApplication = {
  ...Service('/admin/face/competition-application/:id/'),
  availableDistricts(params) {
    return axios.get(
      '/admin/face/competition-application/available-districts/',
      { params }
    )
  },
  export: (urlParams, payload) => {
    const url = '/admin/face/competition-application/export/'
    return axios.get(prepareURL(url, urlParams), payload)
  }
}

export const Example = Service('/admin/examples/:id/')

export const Widget = {
  ...Service('/admin/widgets/:id/'),
  types(params) {
    return axios.get('/widgets/admin/types/', { params })
  },
  validate(payload) {
    return axios.post('/widgets/admin/validate/', payload)
  },
  available(params) {
    return axios.get('/widgets/admin/available/', { params })
  },
  preview(payload) {
    return axios.post('/widgets/admin/preview/', payload)
  }
}

export const Menu = {
  ...Service('/admin/menu/menu/')
}

export const FooterMenu = {
  ...Service('/admin/menu/footer/')
}

export const Link = {
  availableLinkOptions() {
    return axios.get('/admin/links/available-options/')
  },
  availableWidgets(params) {
    return axios.get('/admin/links/available-widgets/', { params })
  }
}

export const Auth = {
  login(payload) {
    return axios.post('/public/users/auth/login/', payload)
  }
}

export const Image = {
  ...Service('/admin/images/:id/'),
  save: (payload, onUploadProgress) => {
    const formData = getFormDataFromJSON(payload)
    return axios.post('/admin/images/', formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress
    })
  },
  update: (urlParams, payload) => {
    const formData = getFormDataFromJSON(payload)
    const defaultUpdate = Service('/admin/images/:id/')['update']
    return defaultUpdate(urlParams, formData, {
      'content-type': 'multipart/form-data'
    })
  }
}

export const Catalog = {
  ...Service('/admin/images/catalogs/:id/')
}

export const User = {
  ...Service('/admin/users/:id/')
}

export const Dashboard = {
  getContentCounters() {
    return axios.get('/admin/dashboard/content-counters/')
  },
  getRecentPages() {
    return axios.get('/admin/dashboard/recent-pages/')
  },
  getUser() {
    return axios.get('/admin/dashboard/user/')
  }
}

export const ExportedFiles = {
  ...Service('/admin/face/exported-svg/:id/'),
  availableStatuses(params) {
    return axios.get('/admin/face/exported-svg/available-statuses/', { params })
  },
  download: (url, downloadProgressCallback) => {
    return axios.get(url, {
      responseType: 'blob',
      onDownloadProgress: evt => {
        if (downloadProgressCallback) {
          downloadProgressCallback(parseInt((evt.loaded / evt.total) * 100))
        }
      }
    })
  }
}

export const Task = {
  ...Service('/admin/tasks/:id/'),
  availableStatuses(params) {
    return axios.get('/admin/tasks/available_statuses/', { params })
  },
  availableTasks(params) {
    return axios.get('/admin/tasks/available_tasks/', { params })
  },
  retryTask: (urlParams, payload) => {
    return axios.post(prepareURL('/admin/tasks/:id/retry/', urlParams), payload)
  }
}
